import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import moment from 'moment';

import styles from 'features/faults-history/views/components/faults-history-resolved-status.module.scss';

interface ResolvedStatusProps {
  resolvedOn?: string;
}

const FaultsHistoryResolvedStatus = ({ resolvedOn }: ResolvedStatusProps) => {
  const { t } = useTranslation('faultsHistory');

  if (resolvedOn) {
    return <>{moment(resolvedOn).format('DD-MM-YYYY · HH:mm:ss').toString()}</>;
  } else {
    return (
      <div className={`${styles.status} ${styles.backgroundColorStatusOpen}`}>
        <Typography className={styles.statusText} variant="overline">
          {t(`status.Open`)}
        </Typography>
      </div>
    );
  }
};

export default FaultsHistoryResolvedStatus;
